const tabs = {
  roulette: [],
  nuevo: [],
  popular: [],
  xMas: [],
};

export const liveCasinoGames = [
  '51', // European Roulette
  '20328', // Dynamic European Roulette
  // European Roulette (Belgium) -
  // Dynamic European Roulette (Belgium) -
  '20331', // Onyx Auto Roulette
  '20329', // Dynamic Roulette 120x (Entertainer)
  '20333', // Vegas Roulette 500x (Entertainer)
  '20011', // Live Altın Rulet (Dealer)
  '20330', // Live European Roulette (Dealer)
  '20332', // Live Speed Roulette (Dealer)
  // Live Roulette - Bulgarian (Dealer) -
  '20335', // Live Roulette - Russian (Dealer)
  '20359', // Speed Baccarat (Dealer)
  '20360', // "Showtime Roulette 500x"
  '20362', // Extra Crown Deluxe LIVE
  '20373', // Football Thrill
  '20126', // Burning Keno
  '20289', // Superb Keno
  '20212', // Hot Keno
];

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

export { getTab };
